import { __awaiter } from "tslib";
import React, { useEffect, useState } from 'react';
import { EnrichFeatureFlag, EnrichRouter, EnrichUserRole, useUserRoutePermissions, } from '@groupby/enrich-console';
import { EnrichEmptyPage } from '@/pages/enrich-empty-page';
import { SimpleLoading } from '@/components/loading.component';
import { logError } from '@/utils/logger';
import { useFeatureFlagsProvider } from '@/search-for-retail/feature-flags';
export const Enrich = () => {
    const { getUserRole } = useUserRoutePermissions();
    const { featureFlagsService } = useFeatureFlagsProvider();
    const [hasEnrichAccess, setHasEnrichAccess] = useState(false);
    const [isEnrichRoleLoading, setIsEnrichRoleLoading] = useState(false);
    useEffect(() => {
        const loadEnrichRole = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsEnrichRoleLoading(true);
            try {
                const isEnrichAIEnabled = featureFlagsService.isFeatureEnabled(EnrichFeatureFlag.EnrichAI);
                const enrichRole = yield getUserRole();
                setHasEnrichAccess(isEnrichAIEnabled || enrichRole !== EnrichUserRole.Unlicensed);
            }
            catch (e) {
                logError('failed to load enrich role', e);
            }
            finally {
                setIsEnrichRoleLoading(false);
            }
        });
        void loadEnrichRole();
    }, [featureFlagsService, getUserRole]);
    if (isEnrichRoleLoading) {
        return <SimpleLoading />;
    }
    return (hasEnrichAccess ? <EnrichRouter /> : <EnrichEmptyPage />);
};
